/* pantallas-alumno (B): EL ENCABEZADO DE PAGINA (parte 2, "Encabezado de pagina"; tambien el del
   Centro de Estudio de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Titulo de 34 bold (26 en el celular) y debajo el texto de la pantalla en 16 px #9A9A9A (15 en el
   celular; aqui si se ve en el celular). `acciones` va a la derecha desde 768 y debajo del texto en el
   celular (el boton "Dashboard" del Historial). `regreso` va a la izquierda del titulo (Ajustes: el
   boton de regreso de 40, 44 en el celular, con flecha: `BotonDeRegreso`). Sin `texto` no se pinta el
   renglon (Gana creditos). */
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { APRETADO } from './botones';

export default function EncabezadoDePagina({ titulo, texto, acciones, regreso, testid, className = '' }) {
  return (
    <header data-testid={testid} className={`flex flex-col gap-3 md:flex-row md:items-start md:justify-between md:gap-6 ${className}`.trim()}>
      <div className="min-w-0 flex items-start gap-3">
        {regreso ? <div className="shrink-0">{regreso}</div> : null}
        <div className="min-w-0">
          <h1 className="text-[26px] md:text-[34px] leading-tight font-bold text-[#F4F4F3] break-words">{titulo}</h1>
          {texto ? <p data-parte="texto" className="mt-1 text-[15px] md:text-[16px] leading-snug text-[#9A9A9A] break-words">{texto}</p> : null}
        </div>
      </div>
      {acciones ? <div data-parte="acciones" className="flex flex-wrap items-center gap-2 md:shrink-0">{acciones}</div> : null}
    </header>
  );
}

export function BotonDeRegreso({ etiqueta, onClick, testid }) {
  return (
    <button type="button" aria-label={etiqueta} title={etiqueta} onClick={onClick} data-testid={testid}
      className={`w-11 h-11 md:w-10 md:h-10 rounded-xl bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3] flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${APRETADO}`}>
      <ArrowLeft className="w-5 h-5" aria-hidden="true" />
    </button>
  );
}
